import { Link } from "react-router-dom";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
}

export default function EmptyState({
  icon = "ri-search-eye-line",
  title,
  description,
  actionLabel,
  actionTo,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100/60 px-6 py-16 text-center">
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-600">
        <i className={`${icon} text-3xl`} aria-hidden="true"></i>
      </div>
      <h3 className="text-base font-semibold text-foreground-950 md:text-lg">{title}</h3>
      {description && <p className="mt-2 max-w-md text-sm text-foreground-600">{description}</p>}
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="mt-6 inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          {actionLabel}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}